import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Button, FooterActionBar } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { testIds } from '../../../../tests/constants';
import { getMessageKey } from '../../../utils/utils';

function CertsConsultFooter({
  isActionLoading,
  setIsConsultModalOpen,
  isConsultValid,
  handleSubmit,
}) {
  const { CONSULT_MODAL_SUBMIT_BUTTON } = testIds;
  const { messages } = useSelector((state) => state?.user);
  const intl = useIntl();

  return (
    <FooterActionBar className='CertsConsultModal-footer' size='large'>
      <div className='CertsConsultModal-actionButtons'>
        <Button
          type='button'
          kind='ghost'
          size='medium'
          isDisabled={isActionLoading}
          onClick={() => {
            setIsConsultModalOpen(false);
          }}>
          {messages.CERTS_CANCEL ||
            localize(intl, getMessageKey('CERTS_CANCEL'))}
        </Button>
        <Button
          className='CertsConsultModal-submitButton'
          type='button'
          kind={isConsultValid ? 'filled' : 'outlined'}
          size='medium'
          onClick={handleSubmit}
          isLoading={isActionLoading}
          loaderText='Submitting'
          dataTestId={CONSULT_MODAL_SUBMIT_BUTTON}>
          {messages.CERTS_SUBMIT ||
            localize(intl, getMessageKey('CERTS_SUBMIT'))}
        </Button>
      </div>
    </FooterActionBar>
  );
}

CertsConsultFooter.propTypes = {
  isActionLoading: PropTypes.bool.isRequired,
  setIsConsultModalOpen: PropTypes.func.isRequired,
  isConsultValid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default CertsConsultFooter;
